/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface RoleDataFrame
 */
export interface RoleDataFrame {
    /**
     * 
     * @type {number}
     * @memberof RoleDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof RoleDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof RoleDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Role>}
     * @memberof RoleDataFrame
     */
    data: Array<Role>;
}

export function RoleDataFrameFromJSON(json: any): RoleDataFrame {
    return RoleDataFrameFromJSONTyped(json, false);
}

export function RoleDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(RoleFromJSON)),
    };
}

export function RoleDataFrameToJSON(value?: RoleDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(RoleToJSON)),
    };
}


